import axios from '@dap/shared-utils/http.js';

export default {
    // 定向包列表
    getTableList (params) {
        return axios.get('/dapper/api/aud/v2/tt_audience/list', { params });
    },
    // 删除定向包
    deleteAudience (params) {
        return axios.delete('/dapper/api/aud/v2/tt_audience', { params });
    },
    // 启停
    putSwitch (params) {
        return axios.put('/dapper/api/aud/v2/tt_audience',  params , {
            headers: { 'Content-Type': 'application/json' },
        });
    },

    // 详情
    getDetail (params) {
        return axios.get('/dapper/api/aud/v2/tt_audience', { params });
    },
    //定向包关联项目
    getProject (params) {
        return axios.get('/dapper/api/aud/v2/tt_audience/rel/project', { params });
    },
    // 日志
    getLog (params) {
        return axios.get('/dapper/api/aud/v2/tt_audience/log', { params });
    },


    // 添加/编辑 定向包
    editAudience (params = {}) {
        return axios.post('/dapper/api/aud/v2/tt_audience', params, {
            headers: { 'Content-Type': 'application/json' },
        });
    },
    // 获取头条字典
    getOrientationDic (params = {}) {
        return axios.get('/dapper/api/aud/orientation', { params });
    },

    // 获取抖音粉丝列表
    getAwemeFanListData (params = {}) {
        return axios.get('/dapper/api/aud/aweme_fan/list', { params });
    },
    // 获取抖音用户
    getAwemeSearch (params) {
        return axios.get('/dapper/api/aud/aweme_fan/search', { params }, {
            headers: { 'Content-Type': 'application/json' },
        });
    },
    // 获取穿山甲
    getSuperiorData (params) {
        return axios.get('/dapper/api/aud/v2/tt_audience/flow_package', { params });
    },
    // 获取行为兴趣 选项值
    getToutiaoCategory (params = {}) {
        return axios.get('/dapper/api/aud/action_interest/category', { params });
    },
    // 获取行为兴趣关键词
    getToutiaoKeywords (params = {}) {
        return axios.get('/dapper/api/aud/action_interest/keyword', { params });
    },
};
